import { useSearchParams } from 'react-router-dom';

export const useQueryParams = (key: string): string | null => {
  const [searchParams] = useSearchParams();
  return searchParams.get(key); 
};
 